import FeedbackComponent from '@/components/base/FeedbackComponent'
import EmployersComponent from '@/components/dashboard/impersonators/employers/Employers.vue'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {UserModel} from '@/models/User.model'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {KeyValuePair, ServiceApi} from '@payroll/optimus-common'
import {FieldType, SearchFieldModel} from '@payroll/search-results-widget/src/models/SearchField.model'
import Component from 'vue-class-component'

import {Getter} from 'vuex-class'

@Component({
    components: {
        EmployersComponent
    }
})
export default class ImpersonatorsComponent extends FeedbackComponent {

    private readonly fakeEmployerUsersPath: string = 'getFakeEmployerUsers'
    private readonly createFakeEmployerUserPath: string = 'createFakeEmployerUser'
    private readonly updateFakeEmployerUserPath: string = 'updateFakeEmployerUser'

    @Getter('userTypes', StoreNamespace.SEARCH)
    public userTypes!: KeyValuePair[]

    private searchFieldsFakeEmployer: SearchFieldModel[] = []
    private columnsFakeEmployer: GridColumn[] = []
    private rowSelected: any = null
    private showModalIsActive: boolean = false
    private showModalUser: boolean = false
    private userObj: UserModel = {} as UserModel
    private searchObject: any
    private isUpdateFakeEmployerUserMode: boolean = false

    mounted() {
        this.$root.$on('closeImpersonatorsModal', this.closeModal)
        this.initSearchFields()
        this.initColumns()
    }

    private initColumns(): void {
        this.columnsFakeEmployer.push({property: 'idNumber', header: 'id_number'})
        this.columnsFakeEmployer.push({property: 'fullName', header: 'name'})
        this.columnsFakeEmployer.push({property: 'phoneNum'})
        this.columnsFakeEmployer.push({property: 'email'})
        this.columnsFakeEmployer.push({property: 'lastSuccessfulLogin', header: 'last_success_login_abbr'})
        this.columnsFakeEmployer.push({property: 'userType.description', header: 'user_type'})
        this.columnsFakeEmployer.push({property: 'status'})
    }

    private initSearchFields(): void {
        this.searchFieldsFakeEmployer.push({
            label: 'id_number',
            property: 'idNumber',
            fieldType: FieldType.TEXT_FIELD,
            maxLength: 16
        })
        this.searchFieldsFakeEmployer.push({
            label: 'name',
            property: 'fullName',
            fieldType: FieldType.TEXT_FIELD,
            maxLength: 50
        })

        if (this.userTypes && this.userTypes.length) {
            this.searchFieldsFakeEmployer.push({
                label: 'user_type',
                property: 'userType',
                fieldType: FieldType.SELECT_FIELD,
                selectOptions: this.userTypes,
                unSelectFirst: true
            })
        }
    }

    private getGridFakeEmployerData(searchObject: any): void {
        this.searchObject = searchObject
        new ServiceApi()
            .setToken(this.accessToken)
            .setRequestName(this.fakeEmployerUsersPath)
            .setRequestBody(searchObject)
            .post(this)
    }

    onSuccess(data: any, requestName?: string, message?: string): void {
        switch (requestName) {
            case this.fakeEmployerUsersPath:
                this.$emit('successResults', data)
                break
            case this.createFakeEmployerUserPath:
            case this.updateFakeEmployerUserPath:
                this.createdUpdatedFakeUser()
                break
        }
    }

    private createdUpdatedFakeUser(): void {
        this.showModalUser = false
        this.$root.$emit('showAlertNotification', {
            toShow: true,
            message: this.isUpdateFakeEmployerUserMode ? 'user_updated_succeeded' : 'user_created_succeeded',
            icon: 'checkCircle',
            secondsToDisappear: 3
        })

        this.searchObject.pageNumber = !this.isUpdateFakeEmployerUserMode ? 0 : this.searchObject.pageNumber
        this.getGridFakeEmployerData(this.searchObject)

        this.modalCreateUpdateFakeUserClosed()
    }

    onRowClick(row: any) {
        this.rowSelected = row
        this.showModalIsActive = true
    }

    closeModal(modalObj: any): void {
        this.showModalIsActive = false

        if (modalObj.updateSent) {
            this.$root.$emit('showAlertNotification', {
                toShow: true,
                message: 'updating_impersonate',
                icon: 'spinner',
            })
        } else if (modalObj.updateSucceeded) {
            this.$root.$emit('showAlertNotification', {
                toShow: true,
                message: 'authorize_to_impersonate_succeeded',
                icon: 'checkCircle',
                secondsToDisappear: 3
            })
        }
    }

    public onAddClicked(): void {
        this.userObj = {
            idNumber: '',
            firstName: '',
            lastName: '',
            phoneNum: '',
            email: '',
            isActive: true,
            userType: this.userTypes[0].value
        } as UserModel
        this.showModalUser = true
    }

    public onCreateUpdateFakeUser(): void {
      if (this.userObj.userType) {
        // @ts-ignore
            this.userObj.secGroupKey = +this.userObj.userType.value
            delete this.userObj.userType
        }

        if (this.isUpdateFakeEmployerUserMode) {
            let id: string | undefined = this.userObj.id
            delete this.userObj.id
            new ServiceApi()
                .setToken(this.accessToken)
                .setPathVariable(id || '')
                .setRequestName(this.updateFakeEmployerUserPath)
                .setRequestBody(this.userObj)
                .put(this)
        } else {
            new ServiceApi()
                .setToken(this.accessToken)
                .setRequestName(this.createFakeEmployerUserPath)
                .setRequestBody(this.userObj)
                .post(this)
        }

    }

    public onEditClick(data: UserModel): void {
        this.isUpdateFakeEmployerUserMode = true
        this.userObj = {
            id: data.id,
            idNumber: data.idNumber,
            firstName: data.firstName,
            lastName: data.lastName,
            phoneNum: data.phoneNum,
            email: data.email,
            isActive: data.isActive,
            userType: data.userType
        } as UserModel
        this.showModalUser = true
    }

    private modalCreateUpdateFakeUserClosed(): void {
        this.cleanServerErrorMessages()
        this.isUpdateFakeEmployerUserMode = false
    }
}



